import React, { useState, useEffect } from 'react'
import { ProductBrowseTiles } from '../home/productBrowseTiles'
import { ProductFilterTile } from './productFilterTile'
import { useGetExcludeListDataByCustomerId } from'./hooks'

export const HsProductBrowse = props => {
    const [scroll, setScroll] = useState(false);
    const [productData, setProductData] = useState([])
    const [modFilterData, setModFilterData] = useState({})    
    const metalOptionOsrs = JSON.parse(sessionStorage.getItem("selectedMetalOptions"))

    const { isCustomerInCatalogExcludeList } = useGetExcludeListDataByCustomerId(
        props.excludeList, 
        props.catalogOSR,
        props.additionalData?.customerId
    )

    useEffect(() => {
        window.addEventListener("scroll", () => {
            setScroll(window.scrollY < 10);

        });
    }, []);

    useEffect(() => {
        return sessionStorage.removeItem("selectedMetalOptions")
    }, [])

    useEffect(() => {
        let tempFilterObj = {...props.filterData};
        if(props?.pbData?.products?.length>0) {
            props?.filterData?.filterGroups?.forEach((filter, index) => {
                filter?.filters?.forEach((subFilter, innerIndex) => {
                    let foundProducts = props?.pbData?.products?.filter((product)=> {
                        return subFilter?.filterItems?.includes(product.productOsr);
                    })
                    if(foundProducts?.length==0) {
                        tempFilterObj?.filterGroups[index]?.filters?.splice(innerIndex, 1);
                    }
                });
            })
            setModFilterData(tempFilterObj);
        } else if(props?.pbData?.products?.length==0) {
            setModFilterData({});
        }
    }, [props?.pbData])

    const getFilteredMetalProducts = () => {
        const productsData = { ...props.filteredPbData }
        productsData.products?.length > 0 && productsData.products.map((pObj, index) => {
            const flavouredProdObj = {}
            const flavouredimageUrl = `${pObj.imageUrl.replace("version=2", "version=3")}&option=v1/${metalOptionOsrs?.length > 0 && metalOptionOsrs[0]}`
            flavouredProdObj.imageUrl = flavouredimageUrl
            productsData.products[index] = { ...productsData.products[index], ...flavouredProdObj }
        })
        setProductData({ "products": [...productsData?.products] })
    }
    
    useEffect(()=> {
        if(metalOptionOsrs?.length > 0){
            getFilteredMetalProducts()
        }else {
            setProductData({ "products": [...(props?.filteredPbData?.products || [])] })
        }
    },[props.filteredPbData])


    const allProducts = Object.keys(productData)?.length > 0 ? productData?.products : props.pbData?.products?.sort((a, b) => a.orderSeq - b.orderSeq);

    const { nonBuckleProducts, buckleProducts } = (allProducts || []).reduce(
        (acc, pObj) => {
            if (pObj.groupOsr && pObj.groupOsr?.includes("BELT-BUCKLE")) {
                acc.buckleProducts.push(pObj);
            } else {
                acc.nonBuckleProducts.push(pObj);
            }
            
            return acc;
        },
        { nonBuckleProducts: [], buckleProducts: [] }
    )

    const isHiddenNonBuckleProductsTile = nonBuckleProducts.length <= 0;

    if(props.pbData){
        return (
            <>
                <div hidden={isHiddenNonBuckleProductsTile}>
                    <div>
                        <span className="px-2 pt-2 h5">{props.fromHsGrad ? props.pbData?.displayName : "Individual Products"}</span>
                        {!props.fromHsGrad && <span className="fontSizeXS ml-3 text-underline cursorPointer" onClick={props.shopAll}>{`Shop all (${props.pbData?.products?.length})`}</span>}
                    </div>
                    <div className='container-fluid'><hr /></div>
                </div>
    
                <div className={window.scrollY === 0 ? "filter" : scroll ? "filter" : "filter-in"}>
                { props.ProductBrowseFiltersBar && (
                    <ProductFilterTile 
                        pbData={props.pbData} 
                        filteredPbData={props.filteredPbData} 
                        filterData={modFilterData} 
                        setFilteredPbData={props.setFilteredPbData} 
                        selectedGroup={props.selectedGroup}
                        setFilteredQuickData={props.setFilteredQuickData} 
                        filteredItems={props.filteredItems} 
                        setSelectedGroup={props.setSelectedGroup} 
                        isUSCustomer={props.isUSCustomer} 
                        additionalData={props.additionalData}
                        schoolStoreEvents={props.schoolStoreEvents}
                    />)}
                </div> 
                <div hidden={isHiddenNonBuckleProductsTile}>
                    <ProductBrowseTiles 
                        pbData={{products: nonBuckleProducts}} 
                        fromHsJwl={true} 
                        pageContent={props.pageContent} 
                        productInfo={{"performSort": false}}
                        promoCodes={props.promoCodes}
                        isCustomerInExcludeList={isCustomerInCatalogExcludeList}
                        schoolStoreEvents={props.schoolStoreEvents}
                    /> 
                </div>
              
                {buckleProducts.length > 0 ? <>
                    <div className='pt-4'>
                        <span className="px-2 pt-2 h5">Belt Buckles</span>
                    </div>
                    <div className='container-fluid'><hr /></div>
                    
                    <ProductBrowseTiles 
                        pbData={{products: buckleProducts}}  
                        fromHsJwl={true} 
                        pageContent={props.pageContent} 
                        productInfo={{"performSort": false}}
                        promoCodes={props.promoCodes}
                        isCustomerInExcludeList={isCustomerInCatalogExcludeList}
                        schoolStoreEvents={props.schoolStoreEvents}
                    /> 
               </> : null}
            </>
	    )
    }else{
        return null
    }
}
